// Turns iframes with data-consent-src into click-to-load placeholders (DSGVO 2-click solution).
(function () {
  var notice = document.documentElement.getAttribute('data-consent-notice') || 'Mit Klick wird das Video vom externen Anbieter geladen.';
  var label = document.documentElement.getAttribute('data-consent-label') || 'Video laden';
  document.querySelectorAll('iframe[data-consent-src]').forEach(function (iframe) {
    var host = '';
    try { host = new URL(iframe.getAttribute('data-consent-src')).hostname.replace('www.', ''); } catch (e) {}
    var box = document.createElement('div');
    box.className = 'consent-embed';
    box.innerHTML = '<button type="button" class="consent-embed__btn btn btn-primary"></button><p class="consent-embed__notice"></p>';
    box.querySelector('button').textContent = label;
    box.querySelector('p').textContent = notice + (host ? ' (' + host + ')' : '');
    box.querySelector('button').addEventListener('click', function () {
      iframe.src = iframe.getAttribute('data-consent-src');
      iframe.removeAttribute('data-consent-src');
      box.replaceWith(iframe);
    });
    iframe.replaceWith(box);
  });
})();
